import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import { useAuthStore } from '../stores/auth' // Pfad anpassen falls nötig

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'dashboard' },
  },
  {
    name: 'admin',
    path: '/',
    component: () => import('../layouts/AppLayout.vue'),
    redirect: { name: 'dashboard' },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        redirect: { name: 'users' },
      },
      {
        name: 'settings',
        path: 'settings',
        component: () => import('../pages/settings/Settings.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'files',
        path: 'files',
        component: () => import('../pages/files/Page.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'preferences',
        path: 'preferences',
        component: () => import('../pages/preferences/Preferences.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'users',
        path: 'users',
        component: () => import('../pages/users/UsersPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },

      {
        name: 'history',
        path: 'history',
        component: () => import('../pages/History.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'userActionLog',
        path: 'userActionLog',
        component: () => import('../pages/UserActionLog.vue'),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/auth',
    component: () => import('../layouts/AuthLayout.vue'),
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        name: 'logout',
        path: 'logout',
        component: () => import('../pages/auth/Logout.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],

    meta: {
      requiresAuth: false,
    },
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),

    meta: {
      requiresAuth: true,
    },
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)
  console.log('requiresAuth', requiresAuth)
  console.log('authentificated', authStore.authentificated)
  if (requiresAuth && !authStore.authentificated) {
    return next({ name: 'login' })
  }

  next()
})

export default router
